class CardsHighlights {
  constructor() {
    this.swiper = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initSwiper());
    } else {
      this.initSwiper();
    }

    // Handle window resize
    window.addEventListener('resize', this.debounce(() => this.handleResize(), 250));
  }

  initSwiper() {
    const swiperElement = document.querySelector('.cards-highlights__swiper');
    if (!swiperElement) return;

    // Initialize Swiper only on mobile/tablet (1024px and below)
    if (window.innerWidth <= 1024) {
      this.createSwiper();
    }
  }

  createSwiper() {
    const swiperElement = document.querySelector('.cards-highlights__swiper');
    if (!swiperElement || this.swiper) return;

    this.swiper = new Swiper('.cards-highlights__swiper', {
            slidesPerView: 1.1,
              spaceBetween: 16,
              slidesOffsetBefore: 10, 
              slidesOffsetAfter: 10, 
              centeredSlides: false,
              grabCursor: true,
              breakpoints: {
                600: {
                  slidesPerView: 2,
             spaceBetween: 16,
         },
              },
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      },
      // Keyboard navigation
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      // Touch settings
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      allowTouchMove: true,
      touchStartPreventDefault: false,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  handleResize() {
    const shouldHaveSwiper = window.innerWidth <= 1024;
    const hasSwiper = this.swiper !== null;

    if (shouldHaveSwiper && !hasSwiper) {
      this.createSwiper();
    } else if (!shouldHaveSwiper && hasSwiper) {
      this.destroySwiper();
    }
  }

  // Utility function to debounce resize events
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize when the script loads
document.addEventListener('DOMContentLoaded', () => {
  new CardsHighlights();
});

// Also initialize immediately if DOM is already ready
if (document.readyState !== 'loading') {
  new CardsHighlights();
}
